module.exports = __webpack_public_path__ + "static/media/SIPCLogo.43085ae1.svg";